
import { Suspense } from "react";
import { SlideContext } from "@/components/deck/_context";
import { getLazySlide } from "@/components/deck/_lazySlides";
import { getVisibleSlides } from "@/decks/registry";
import type { DeckDef } from "@/decks/types";

const SLIDE_WIDTH = 1600;
const SLIDE_HEIGHT = 900;

// Recibe el deck ya resuelto (compilado + overlay de config) desde App.
export function DeckPrint({ deck }: { deck: DeckDef }) {
  const slides = getVisibleSlides(deck);

  return (
    <div className="bg-landing-black">
      {slides.map((slide, index) => {
        const Component = getLazySlide(deck.id, slide.id, slide.load);
        const finalFragment = slide.fragments ?? 0;
        return (
          <div
            key={slide.id}
            data-slide={slide.id}
            className="relative overflow-hidden"
            style={{
              width: SLIDE_WIDTH,
              height: SLIDE_HEIGHT,
              breakAfter: "page",
            }}
          >
            <SlideContext.Provider
              value={{
                activeFragment: finalFragment,
                isActive: true,
                number: index + 1,
              }}
            >
              <Suspense fallback={null}>
                <Component activeFragment={finalFragment} isActive />
              </Suspense>
            </SlideContext.Provider>
          </div>
        );
      })}
    </div>
  );
}
